export const SHOWROOM = 'showroom';
export const LOAN_TRACKER = 'loan_tracker';
